import React from 'react';
import clsx from 'clsx';
import BlockTitleGroup from '../block-title-group';
import {useStyles} from './helpers';
import { useDispatch } from 'react-redux';
import { setPostResultDenomination } from '../../../freespin/store/thunk/setPostResultDenomination';

const BlockFreespin = ({formik}) => {
    const [sumBonus, setSumBonus] = React.useState(false);
    const classes = useStyles();
    const dispatch = useDispatch();

    return (
        <div>
            <BlockTitleGroup setShowBlock={setSumBonus} showBlock={sumBonus} title="Настройка фриспинов" />
            {
                sumBonus &&
                <>
                    <div style={{display: 'flex'}}>
                        <label htmlFor="game_uuid" className={clsx(classes.wrapLabel, classes.beginBonusLabel)}>
                            <span className={classes.helper}>Получить деноминацию по игре</span>
                            <input 
                                type="text" 
                                name="game_uuid" 
                                id="game_uuid" 
                                className={classes.text} 
                                value={formik.values.game_uuid} 
                                onChange={(v) => formik.setFieldValue('game_uuid', v.target.value)}/>
                        </label>
                        <div style={{display: 'flex', alignItems: 'center', marginLeft: 20}}>  
                            <span style={{
                                color: 'rgb(36, 38, 62)',
                                border: '1px solid rgb(255, 206, 1)',
                                background: 'rgb(255, 206, 1)',
                                cursor: 'pointer',
                                padding: '5px 10px',
                                overflow: 'hidden',
                                fontSize: '14px',
                                maxHeight: '48px',
                                fontFamily: 'PT Sans, sans-serif',
                                fontWeight: 400,
                                userSelect: 'none',
                                whiteSpace: 'nowrap',
                                marginRight: '12px',
                                borderRadius: '16px',
                                textOverflow: 'ellipsis',
                                textTransform: 'uppercase',
                            }}
                                onClick={() => dispatch(setPostResultDenomination({game_uuid: formik.values.game_uuid}))}
                            >Проверить</span>
                        </div>
                    </div>  
                    <div style={{display: 'flex', columnGap: 12}}>
                        <label htmlFor="bet_id" className={clsx(classes.wrapLabel, classes.beginBonusLabel)}>
                            <span className={classes.helper}>Bet id</span>
                            <input 
                                type="text" 
                                name="bet_id" 
                                id="bet_id" 
                                className={classes.text} 
                                value={formik.values.bet_id} 
                                onChange={(v) => formik.setFieldValue('bet_id', v.target.value)}/>
                        </label>
                        <label htmlFor="denomination" className={clsx(classes.wrapLabel, classes.beginBonusLabel)}>
                            <span className={classes.helper}>Denomination</span>
                            <input 
                                type="text" 
                                name="denomination" 
                                id="denomination" 
                                className={classes.text} 
                                value={formik.values.denomination} 
                                onChange={(v) => formik.setFieldValue('denomination', v.target.value)}/>
                        </label>
                        <label htmlFor="total_bet" className={clsx(classes.wrapLabel, classes.beginBonusLabel)}>
                            <span className={classes.helper}>Total bet</span>
                            <input 
                                type="text" 
                                name="total_bet" 
                                id="total_bet" 
                                className={classes.text} 
                                value={formik.values.total_bets} 
                                onChange={(v) => formik.setFieldValue('total_bets', v.target.value)}/>
                        </label>
                        <label htmlFor="quantity" className={clsx(classes.wrapLabel, classes.beginBonusLabel)}>
                            <span className={classes.helper}>Quantity</span>
                            <input 
                                type="text" 
                                name="quantity" 
                                id="quantity" 
                                className={classes.text} 
                                value={formik.values.quantity} 
                                onChange={(v) => formik.setFieldValue('quantity', v.target.value)}/>
                        </label>
                    </div>
                </>
            }
        </div>
    )
}

export default BlockFreespin;